<div class="container mx-auto p-6">
  <h2 class="text-2xl font-bold mb-6">Configuración de Presupuestos</h2>

  <!-- Listado de Categorías y Subcategorías -->
  <div class="mb-8">
    <div class="flex items-center justify-between mb-4">
      <h4 class="text-xl font-semibold">Categorías y Subcategorías</h4>
      <div class="flex space-x-2">
        <button *appHasPermission="'CONFIG_BUDGETS_CREATE'" 
                class="bg-green-500 text-white hover:bg-green-600 font-bold py-2 px-4 rounded focus:outline-none" 
                (click)="addCategory()">
          Crear Categoría
        </button>
        <button *appHasPermission="'CONFIG_BUDGETS_SUBCATEGORY'" 
                class="bg-blue-500 text-white hover:bg-blue-600 font-bold py-2 px-4 rounded focus:outline-none" 
                (click)="addSubcategory()">
          Crear Subcategoría
        </button>
      </div>
    </div>
    <div class="bg-white rounded-lg">
      <ul>
        <li *ngFor="let category of categories; let i = index" class="mb-4 border-b last:border-none">
          <div 
            class="flex items-center justify-between cursor-pointer p-4 hover:bg-gray-100 transition-colors duration-200 border-b border-neutral-200"
            (click)="toggleCategory(i)">
            <div class="flex items-center flex-1">
              <svg 
                class="w-5 h-5 transform transition-transform duration-200 mr-2"
                [class.rotate-90]="category.expanded"
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
              <h4 class="font-bold text-lg">{{ category.name }}</h4>
              
              <!-- 🆕 Audit Info para Categoría -->
              <div class="ml-4 flex-1">
                <app-audit-info 
                  [auditData]="{
                    createdBy: category.createdBy,
                    createdAt: category.createdAt,
                    updatedBy: category.updatedBy,
                    updatedAt: category.updatedAt,
                    deletedBy: category.deletedBy,
                    deletedAt: category.deletedAt,
                    isDeleted: category.isDeleted
                  }"
                  layout="horizontal"
                  size="sm">
                </app-audit-info>
              </div>
            </div>
            <div class="flex items-center space-x-2">
              <!-- Botón Ver (siempre visible con permiso de lectura) -->
              <button class="text-neutral-500 hover:text-blue-600 focus:outline-none p-1 rounded hover:bg-blue-50 transition-colors" 
                      (click)="viewCategory(category); $event.stopPropagation()"
                      title="Ver detalles">
                <i class="fas fa-eye"></i>
              </button>
              <!-- Botón Editar (solo con permiso de actualización) -->
              <button *appHasPermission="'CONFIG_BUDGETS_UPDATE'" 
                      class="text-neutral-500 hover:text-green-600 focus:outline-none p-1 rounded hover:bg-green-50 transition-colors" 
                      (click)="editCategory(category); $event.stopPropagation()"
                      title="Editar categoría">
                <i class="fas fa-edit"></i>
              </button>
            </div>
          </div>
          <ul *ngIf="category.expanded" class="pl-8 mt-2">
            <li *ngFor="let subcategory of category.budgetSubcategories" class="text-gray-700 py-3 flex justify-between items-center border-b border-neutral-200">
              <div class="flex items-center flex-1">
                <span class="font-medium">{{ subcategory.name }}</span>
                
                <!-- 🆕 Audit Info para Subcategoría -->
                <div class="ml-4 flex-1">
                  <app-audit-info 
                    [auditData]="{
                      createdBy: subcategory.createdBy,
                      createdAt: subcategory.createdAt,
                      updatedBy: subcategory.updatedBy,
                      updatedAt: subcategory.updatedAt,
                      deletedBy: subcategory.deletedBy,
                      deletedAt: subcategory.deletedAt,
                      isDeleted: subcategory.isDeleted
                    }"
                    layout="horizontal"
                    size="sm">
                  </app-audit-info>
                </div>
              </div>
              <div class="flex items-center space-x-2">
                <!-- Botón Ver (siempre visible con permiso de lectura) -->
                <button class="text-neutral-500 hover:text-blue-600 focus:outline-none p-1 rounded hover:bg-blue-50 transition-colors" 
                        (click)="viewSubcategory(subcategory)"
                        title="Ver detalles">
                  <i class="fas fa-eye"></i>
                </button>
                <!-- Botón Editar (solo con permiso de subcategorías) -->
                <button *appHasPermission="'CONFIG_BUDGETS_SUBCATEGORY'" 
                        class="text-neutral-500 hover:text-green-600 focus:outline-none p-1 rounded hover:bg-green-50 transition-colors" 
                        (click)="editSubcategory(subcategory)"
                        title="Editar subcategoría">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Crear/Editar/Ver categoría modal -->
<app-shared-modal [(isOpen)]="newCategoryModal">  
  <app-new-category 
    [categoryId]="categoryId" 
    [readonly]="categoryReadonly"
    (closeModal)="closeCategoryModal()" 
    (retrieveData)="onRetrieveData()">
  </app-new-category>
</app-shared-modal>

<!-- Crear/Editar/Ver subcategoría modal -->
<app-shared-modal [(isOpen)]="newSubcategoryModal">  
  <app-new-subcategory 
    [subCategoryId]="subCategoryId" 
    [readonly]="subcategoryReadonly"
    (closeModal)="closeSubCategoryModal()" 
    (retrieveData)="onRetrieveData()" 
    #newSubcategory>
  </app-new-subcategory>
</app-shared-modal>





